import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from '@jordan/ui';
import { useAuth } from './AuthProvider';
import { MeProvider } from './MeProvider';

/** Layout route: gate on Firebase auth, then provide the /api/me context to children. */
export function RequireAuth() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <MeProvider>
      <Outlet />
    </MeProvider>
  );
}
